import http from "../mpm-config/http-common";
import * as Constants from '../mpm-config/Constants';

class CessionsCaptureDataService {

    async findAll() {
        return http(window.keycloak.token).get("/cessionCapture/list");
    }
    async findAllPaginated(size = Constants.DEFAULT_TABLE_ROWS, page = 1, searchCriteria) {
        return http(window.keycloak.token).post(`/cessionCapture/list`, { size, page, ...searchCriteria }).then(res => res.data);
    }

    async getForEdit(id) {
        return http(window.keycloak.token).get(`/cessionCapture/forEdit/${id}`).then(res => res.data);
    }
    async getForView(id) {
        return http(window.keycloak.token).get(`/cessionCapture/${id}`).then(res => res.data);
    }

    async statistic(menuCedant) {
        return http(window.keycloak.token).get(`/cessionCapture/statistique/${menuCedant}`).then(res => res.data);
    }

    async create(data) {
        return http(window.keycloak.token).post("/cessionCapture/saveNew", data).then(res => res.data);
    }

    async update(id, data) {
        return http(window.keycloak.token).put(`/cessionCapture/${id}`, data);
    }

    async delete(data) {
        return http(window.keycloak.token).delete(`/cessionCapture/remove`, { data });
    }

    async validate(data) {
        return http(window.keycloak.token).post(`/cessionCapture/validateNew`, data).then(res => res.data);
    }

    async deleteAll() {
        return http(window.keycloak.token).delete(`/cessionCapture/`);
    }

    async searchCessionCaptureAcquereur(data) {
        return http(window.keycloak.token).post(`/cessionCapture/SearchAcquereurCC`, { ...data }).then(res => res.data);
    }

    async loadCessionCaptureSourceCC(data) {
        return http(window.keycloak.token).post(`/cessionCapture/ChargerSourcesCC`, { ...data }).then(res => res.data);
    }

    async saveSourceCC(data) {
        return http(window.keycloak.token).post(`/cessionCapture/saveNewChild`, { ...data }).then(res => res.data);
    }
    async deleteSourceCC(data) {
        return http(window.keycloak.token).get(`/cessionCapture/removeChildFromList/${data}`).then(res => res.data);
    }

    async confirmer(data) {
        return http(window.keycloak.token).put(`/cessionCapture/confirmer`, { ...data }).then(res => res.data);
    }

    async refuser(id) {
        return http(window.keycloak.token).get(`/cessionCapture/refuser/${id}`).then(res => res.data);
    }

    async annuler(data) {
        return http(window.keycloak.token).put(`/cessionCapture/annuler`, { ...data }).then(res => res.data);
    }

    async confirmerAnnulation(data) {
        return http(window.keycloak.token).put(`/cessionCapture/confirmerAnnulation`, { ...data }).then(res => res.data);
    }

    async printEtat(data) {
        return http(window.keycloak.token).post(`/cessionCapture/generateCesCap`, { ...data }).then(res => res.data);
    }

}

export default new CessionsCaptureDataService();